import { types } from "../types";

export const errorAlert = (msg, type) => {
  const alert = { msg, type };
  return async (dispatch) => {
    await dispatch(setError(alert));
    setTimeout(() => {
      dispatch({
        type: types.uiRemoveAlert,
      });
    }, [2500]);
  };
};

export const successAlert = (msg, type) => {
  const alert = { msg, type };

  return async (dispatch) => {
    await dispatch(setSuccess(alert));
    setTimeout(() => {
      dispatch({
        type: types.uiRemoveAlert,
      });
    }, [2500]);
  };
};

export const setSuccessAlertModal = (msg, type) => {
  const alert = { msg, type };

  return (dispatch) => {
    dispatch({
      type: types.uiSetAlertModal,
      payload: alert,
    });
  };
};

export const removeSuccessAlertModal = () => {
  return (dispatch) => {
    dispatch({
      type: types.uiRemoveAlertModal,
    });
  };
};

export const setError = (alert) => ({
  type: types.uiSetAlert,
  payload: alert,
});

export const setSuccess = (alert) => ({
  type: types.uiSetAlert,
  payload: alert,
});
